/**
 * ContentBlockList - Simple list of content blocks
 * 
 * No search/filter - just a clean static list with count in header
 */

import { ContentBlockItem } from "./ContentBlockItem";
import { Skeleton } from "@/components/ui/skeleton";
import { BookOpen } from "lucide-react";

interface ContentBlockListProps {
    blocks: any[] | undefined;
    isLoading: boolean;
}

export const ContentBlockList = ({ blocks, isLoading }: ContentBlockListProps) => {
    if (isLoading) {
        return (
            <div className="space-y-2">
                {[1, 2, 3, 4].map(i => (
                    <div key={i} className="flex items-center gap-3 p-3 bg-white border border-slate-100 rounded-xl">
                        <Skeleton className="w-10 h-10 rounded-lg" />
                        <div className="flex-1">
                            <Skeleton className="h-4 w-3/4 mb-1" />
                            <Skeleton className="h-3 w-1/4" />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (!blocks || blocks.length === 0) {
        return (
            <div className="text-center py-12 bg-slate-50 rounded-xl">
                <span className="text-4xl mb-3 block">📚</span>
                <p className="text-slate-600 font-medium">No content yet</p>
                <p className="text-sm text-slate-400 mt-1">Check back soon</p>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {/* Header */}
            <div className="flex items-center gap-2 px-1">
                <BookOpen className="w-4 h-4 text-slate-500" />
                <h3 className="text-sm font-semibold text-slate-900">
                    Contents
                </h3>
                <span className="text-xs text-slate-400">
                    ({blocks.length})
                </span>
            </div>

            {/* Block List */}
            <div className="space-y-3">
                {blocks.map((block) => (
                    <ContentBlockItem key={block.id} block={block} />
                ))}
            </div>
        </div>
    );
};

export default ContentBlockList;
